import { jsx as _jsx } from "react/jsx-runtime";
import { ProgressBarBase } from './progress-bar-base';
export function ProgressBar(props) {
    return _jsx(ProgressBarBase, { ...props });
}
